// extracted by mini-css-extract-plugin
export default {"toolbar-wrapper":"EditorToolBar_toolbar-wrapper__jqRby"};